// Global
import React from 'react';

// Local
import styles from './Image.module.scss';

export interface ImageProps {
  image: React.ReactNode;
  onImageCTA: React.ReactNode;
  belowImageCTA: React.ReactNode;
  showOpenInNewTabCTA?: boolean;
}

export const Image = (props: ImageProps) => {
  /*
   * Rendering
   */

  return (
    <div
      id="image"
      data-component="authorable/shared/content/image/image"
      className={styles.imageContent}
    >
      <div className={styles.imageContainer}>
        <div className={styles.image}>{props.image}</div>
        {props.showOpenInNewTabCTA && <div className={styles.onImageCTA}>{props.onImageCTA}</div>}
      </div>
      {props.belowImageCTA}
    </div>
  );
};
